import React, { useEffect } from "react";
import styles from "./BusinessFee.module.scss";
import { Divider } from "@material-ui/core";
import { InputLabel, TextField } from "@material-ui/core";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import Select from "../../formUI/Select";
import { useDispatch } from "react-redux";
import axios from "axios";
import { openToastAndSetContent } from "../../../redux/actions/toast/toastActions";
import {
	openLoader,
	closeLoader,
} from "../../../redux/actions/loader/loaderActions";
import { closeModal } from "../../../redux/actions/modal/modalActions";

import { makeStyles } from "@material-ui/core";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import { set } from "date-fns";

const useStyles = makeStyles({
	root: {
		"& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
			border: "none",
		},
		"& .MuiOutlinedInput-input.MuiInputBase-input.MuiInputBase-input.MuiOutlinedInput-input":
			{
				textAlign: "center",
				padding: "8.1px 14px",
			},
	},
	select: {
		"& .MuiOutlinedInput-root": {
			color: "#414141",
			fontFamily: "Avenir",
			fontStyle: "normal",
			fontWeight: "normal",
			fontSize: "14px",
			lineHeight: "16px",
			textTransform: "capitalize",
		},
		"&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
			outline: "none",
		},
		"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
			backgroundColor: "#ffffff",
		},
		"& .MuiInputLabel-root.Mui-focused": {
			color: "#E0E0E0",
		},
		"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
			border: "1px solid #E0E0E0",
		},
	},
});

function BusinessFee({
	id,
	content,
	identifier,
	setBearer,
}: {
	id: number | undefined;
	content?: any;
	identifier: string;
	setBearer: React.Dispatch<React.SetStateAction<boolean>>;
}) {
	const classes = useStyles();
	const dispatch = useDispatch();

	const validate = Yup.object({
		feeType: Yup.string().required("Required"),
		transactionType: Yup.string().required("Required"),
		authOption: Yup.string().required("Required"),
		paymentMethod: Yup.string().required("Required"),
		feeSetting: Yup.string().required("Required"),
		feeSettingValue: Yup.string().required("Required"),
		feeCap: Yup.string().required("Required"),
		feeMin: Yup.string().required("Required"),
		merchantBearsFee: Yup.string().required("Required"),
	});

	const authOption = [
		{
			name: "3ds",
			label: "3ds",
		},
		{
			name: "noauth",
			label: "No Auth",
		},
		{
			name: "pin",
			label: "Pin",
		},
		{
			name: "bank_transfer",
			label: "Bank Transfer",
		},
		{
			name: "ALL",
			label: "All",
		},
	];

	const transactionOption = [
		{
			name: "collection",
			label: "Collection",
		},
		{
			name: "payout",
			label: "Payout",
		},
	];
	const paymentMethodOption = [
		{
			name: "card",
			label: "Card",
		},
		{
			name: "qr",
			label: "QR",
		},
		{
			name: "ussd",
			label: "USSD",
		},
		{
			name: "account",
			label: "Account",
		},
		{
			name: "momo",
			label: "Momo",
		},
		{
			name: "enaira",
			label: "E-Naira",
		},
		{
			name: "phone",
			label: "Phone",
		},
		{
			name: "opay",
			label: "OPay",
		},
	];

	const transactionLocaleOption = [
		{
			name: "local",
			label: "Local",
		},
		{
			name: "international",
			label: "International",
		},
	];
	const feeSettingsOption = [
		{
			name: "flat",
			label: "Flat",
		},
		{
			name: "percentage",
			label: "Percentage",
		},
		{
			name: "mixed",
			label: "Mixed",
		},
	];
	const merchantBearsFeeOption = [
		{
			name: "YES",
			label: "Yes",
		},
		{
			name: "NO",
			label: "No",
		},
	];
	const FeeTypeOption = [
		{
			name: "processing",
			label: "Processing",
		},
		{
			name: "chargeback",
			label: "Chargeback",
		},
	];

	const INITIAL_VALUES = {
		transactionType: content ? content?.transactiontype : "",
		authOption: content ? content?.auth : "",
		paymentMethod: content ? content?.payment : "",
		feeType: content ? content?.feeType : "",
		feeSetting: content ? content?.fee : "",
		feeSettingValue: content ? content?.feeSettingValue : "",
		transactionLocale: content ? content?.transactionlocale : "",
		feeMin: content ? content?.min?.split(" ")[1] : "",
		feeCap: content ? content?.max?.split(" ")[1] : "",
		merchantBearsFee: content ? content?.bear : "",
	};

	useEffect(() => {}, [content]);

	return (
		<div className={styles.generalFourReuse}>
			<h3 className={styles.generalh3}>
				{identifier === "Edit" ? "View " : "Add "} Fee
			</h3>
			<Divider />

			<div className={styles.selectinput}>
				<Formik
					initialValues={INITIAL_VALUES}
					validationSchema={validate}
					onSubmit={(values) => {
						dispatch(openLoader());
						const newObject =
							identifier === "Edit"
								? {
										...values,
										feeCurrency: "NGN",
										feeId: content?.id,
								  }
								: {
										...values,
										feeCurrency: "NGN",
								  };

						axios
							.post(`/v1/business/${id}/fees`, newObject)
							.then((res: any) => {
								setBearer(true);
								dispatch(closeLoader());
								dispatch(
									openToastAndSetContent({
										toastContent: res?.data?.message,
										toastType: "success",
									})
								);
								dispatch(closeModal());
							})
							.catch((err) => {
								dispatch(closeLoader());
								dispatch(
									openToastAndSetContent({
										toastContent:
											err?.response?.data?.message ||
											err?.data?.message ||
											err?.message ||
											err,

										toastType: "error",
									})
								);
							});
					}}
				>
					{(props) => (
						<Form>
							<div
								style={{
									display: "flex",
									flexDirection: "row",
									alignItems: "baseline",
									justifyContent: "space-between",
								}}
							>
								<div
									style={{
										width: "50%",
									}}
								>
									<InputLabel>
										<span className={styles.span}>Transaction type</span>
									</InputLabel>
									<Field
										as={Select}
										helperText={
											<ErrorMessage name="transactionType">
												{(msg) => <span style={{ color: "red" }}>{msg}</span>}
											</ErrorMessage>
										}
										name="transactionType"
										size="small"
										options={transactionOption}
										defaultValue={transactionOption && transactionOption[0]}
										className={classes.select}
										// fullWidth
										style={{
											marginTop: "8px",
											marginBottom: "22px",
										}}
									/>

									<InputLabel>
										<span className={styles.span}>Auth options</span>
									</InputLabel>
									<Field
										as={Select}
										helperText={
											<ErrorMessage name="authOption">
												{(msg) => <span style={{ color: "red" }}>{msg}</span>}
											</ErrorMessage>
										}
										name="authOption"
										size="small"
										options={authOption}
										defaultValue={authOption && authOption[0]}
										className={classes.select}
										// fullWidth
										style={{
											marginTop: "8px",
											marginBottom: "22px",
										}}
									/>

									<InputLabel>
										<span className={styles.span}>
											Should merchant bear fee?
										</span>
									</InputLabel>
									<Field
										as={Select}
										helperText={
											<ErrorMessage name="merchantBearsFee">
												{(msg) => <span style={{ color: "red" }}>{msg}</span>}
											</ErrorMessage>
										}
										name="merchantBearsFee"
										size="small"
										options={merchantBearsFeeOption}
										defaultValue={
											merchantBearsFeeOption && merchantBearsFeeOption[0]
										}
										className={classes.select}
										// fullWidth
										style={{
											marginTop: "8px",
											marginBottom: "22px",
										}}
									/>

									<InputLabel>
										<span className={styles.span}>Payment method</span>
									</InputLabel>
									<Field
										as={Select}
										helperText={
											<ErrorMessage name="paymentMethod">
												{(msg) => <span style={{ color: "red" }}>{msg}</span>}
											</ErrorMessage>
										}
										name="paymentMethod"
										size="small"
										options={paymentMethodOption}
										defaultValue={paymentMethodOption && paymentMethodOption[0]}
										className={classes.select}
										// fullWidth
										style={{
											marginTop: "8px",
											marginBottom: "22px",
										}}
									/>

									<InputLabel>
										<span className={styles.span}>Fee type</span>
									</InputLabel>
									<Field
										as={Select}
										helperText={
											<ErrorMessage name="feeType">
												{(msg) => <span style={{ color: "red" }}>{msg}</span>}
											</ErrorMessage>
										}
										name="feeType"
										size="small"
										options={FeeTypeOption}
										defaultValue={FeeTypeOption && FeeTypeOption[0]}
										className={classes.select}
										// fullWidth
										style={{
											marginTop: "8px",
											marginBottom: "22px",
										}}
									/>

									{identifier === "Edit" ? null : (
										<>
											<InputLabel>
												<span className={styles.span}>OTP</span>
											</InputLabel>
											<Field
												as={TextField}
												helperText={
													<ErrorMessage name="otp">
														{(msg) => (
															<span style={{ color: "red" }}>{msg}</span>
														)}
													</ErrorMessage>
												}
												InputLabelProps={{
													style: { fontSize: "0.8em" },
												}}
												label="Get OTP from Google Authenticator App"
												name="otp"
												variant="outlined"
												margin="normal"
												type="text"
												size="small"
												fullWidth
												className={classes.select}
												style={{
													marginTop: "8px",
												}}
											/>
											<InputLabel>
												<div style={{ display: "flex", alignItems: "center" }}>
													<InfoRoundedIcon />
													<p className={styles.info}>
														If you have not set up your 2FA, kindly{" "}
														<a
															style={{ color: "blue" }}
															href={`/account`}
															target="_blank"
														>
															click here
														</a>
													</p>
												</div>
											</InputLabel>
										</>
									)}
								</div>
								<div
									style={{
										width: "50%",
										marginLeft: "20px",
									}}
								>
									<InputLabel>
										<span className={styles.span}>Transaction locale</span>
									</InputLabel>
									<Field
										as={Select}
										helperText={
											<ErrorMessage name="transactionLocale">
												{(msg) => <span style={{ color: "red" }}>{msg}</span>}
											</ErrorMessage>
										}
										name="transactionLocale"
										size="small"
										options={transactionLocaleOption}
										className={classes.select}
										defaultValue={
											transactionLocaleOption && transactionLocaleOption[0]
										}
										// fullWidth
										style={{
											marginTop: "8px",
											marginBottom: "22px",
										}}
									/>

									<InputLabel>
										<span className={styles.span}>Min fee</span>
									</InputLabel>
									<Field
										as={TextField}
										helperText={
											<ErrorMessage name="feeMin">
												{(msg) => <span style={{ color: "red" }}>{msg}</span>}
											</ErrorMessage>
										}
										name="feeMin"
										variant="outlined"
										margin="normal"
										type="text"
										size="small"
										fullWidth
										className={classes.select}
										style={{
											marginTop: "8px",
											marginBottom: "22px",
										}}
									/>

									<InputLabel>
										<span className={styles.span}>Fee cap</span>
									</InputLabel>
									<Field
										as={TextField}
										helperText={
											<ErrorMessage name="feeCap">
												{(msg) => <span style={{ color: "red" }}>{msg}</span>}
											</ErrorMessage>
										}
										name="feeCap"
										variant="outlined"
										margin="normal"
										type="text"
										size="small"
										fullWidth
										className={classes.select}
										style={{
											marginTop: "8px",
											marginBottom: "22px",
										}}
									/>

									<InputLabel>
										<span className={styles.span}>Fee settings</span>
									</InputLabel>
									<Field
										as={Select}
										helperText={
											<ErrorMessage name="feeSetting">
												{(msg) => <span style={{ color: "red" }}>{msg}</span>}
											</ErrorMessage>
										}
										name="feeSetting"
										options={feeSettingsOption}
										variant="outlined"
										margin="normal"
										type="text"
										size="small"
										// fullWidth
										className={classes.select}
										style={{
											marginTop: "8px",
											marginBottom: "22px",
										}}
									/>

									<InputLabel>
										<span className={styles.span}>Fee settings value</span>
									</InputLabel>
									<Field
										as={TextField}
										helperText={
											<ErrorMessage name="feeSettingValue">
												{(msg) => <span style={{ color: "red" }}>{msg}</span>}
											</ErrorMessage>
										}
										name="feeSettingValue"
										variant="outlined"
										margin="normal"
										type="text"
										size="small"
										fullWidth
										className={classes.select}
										style={{
											marginTop: "8px",
											marginBottom: "22px",
										}}
									/>
								</div>
							</div>

							{identifier === "Edit" ? null : (
								<>
									<button
										style={{
											backgroundColor: "#27AE60",
											fontFamily: "Avenir",
											fontStyle: "normal",
											fontWeight: "bold",
											fontSize: "16px",
											lineHeight: "19px",
											textAlign: "center",
											border: "none",
											outline: "none",
											width: "100%",
											color: "#FFFFFF",
											padding: "13.39px 0",
											borderRadius: "20px",
											marginTop: "30px",
											cursor: "pointer",
										}}
										type="submit"
									>
										Submit
									</button>
								</>
							)}
						</Form>
					)}
				</Formik>
			</div>
		</div>
	);
}

export default BusinessFee;
